import { route, post } from "@utils/network";

export function validateApplicantInfo(data) {
    return post(route("shops/applicants/validate-applicant-info"), { data })
}

export function validateShopInfo(data) {
    return post(route("shops/applicants/validate-shop-info"), { data })
}

export function validateShopAddress(data) {
    return post(route("shops/applicants/validate-shop-address"), { data })
}

export function validateOwnerInfo(businessType, data) {
    return post(route("shops/applicants/validate-owner-info"), { params: { businessType }, data })
}

export function validateBusinessInfo(businessType, data) {
    return post(route("shops/applicants/validate-business-info"), { params: { businessType }, data })
}

export function registerApplicant(data) {
    return post(route("shops/applicants"), { data })
}